/* ============================================================================
   Reway theme — global interactions
   Mobile nav · cart drawer (AJAX + Section Rendering API) · predictive search ·
   quick-shop · add-to-cart. Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: theme.settings.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  }

  /* ----------------------------------------------------- body scroll lock */
  var lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.body.style.overflow = lockCount > 0 ? 'hidden' : '';
  }

  /* --------------------------------------------------------- mobile nav */
  function initMobileNav() {
    var nav = $('[data-rw-mobnav]');
    if (!nav) return;
    function open() { nav.hidden = false; lockScroll(true); }
    function close() { nav.hidden = true; lockScroll(false); }
    $$('[data-rw-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-rw-mobsearch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.querySelector('.rw-header__mobile-search [data-rw-predictive], .rw-header__mobile-search input[name="q"]');
        if (input) { window.scrollTo({ top: 0, behavior: 'smooth' }); input.focus(); }
      });
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-menu-close]') || e.target.matches('.rw-mobnav__overlay')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
  }

  /* --------------------------------------------------------- cart drawer */
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = $('[data-rw-cartdrawer]');
      var self = this;
      $$('[data-rw-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (theme.settings && theme.settings.cartType === 'page') return; // let it navigate
          e.preventDefault();
          self.open();
        });
      });
      document.addEventListener('click', function (e) {
        if (!self.el) return;
        if (e.target.closest('[data-rw-cart-close]') || e.target.matches('.rw-cartdrawer__overlay')) self.close();
        var rm = e.target.closest('[data-rw-cart-remove]');
        if (rm) { e.preventDefault(); self.changeLine(rm.getAttribute('data-rw-cart-remove'), 0); }
        // aantal-stepper (- N +) per regel: leest huidige qty, +/-1, zet absoluut aantal
        var qb = e.target.closest('[data-rw-qty-dir]');
        if (qb && !qb.disabled) {
          e.preventDefault();
          var box = qb.closest('[data-rw-cart-qty]');
          if (box) {
            var line = box.getAttribute('data-rw-cart-qty');
            var valEl = box.querySelector('[data-rw-qty-val]');
            var cur = parseInt((valEl && valEl.getAttribute('data-rw-qty-val')) || '1', 10) || 1;
            var qmax = parseInt(box.getAttribute('data-rw-qty-max') || '0', 10);
            var next = qb.getAttribute('data-rw-qty-dir') === 'inc' ? cur + 1 : cur - 1;
            if (next < 1) return;                 // verwijderen gaat via de aparte x
            if (qmax > 0 && next > qmax) return;  // niet boven voorraad
            box.style.opacity = '.5';             // korte visuele feedback tot refresh
            self.changeLine(line, next);
          }
        }
        // upsell: "+" voegt toe; drawer her-rendert vanzelf. Op de cart-PAGINA herladen we
        // de pagina zodat de nieuwe regel ook in de paginalijst verschijnt.
        var up = e.target.closest('[data-rw-upsell-add]');
        if (up) {
          e.preventDefault();
          up.classList.add('is-loading');
          var onCartPage = !!document.getElementById('rw-cart-form');
          addToCart([{ id: parseInt(up.getAttribute('data-rw-upsell-add'), 10), quantity: 1 }], !onCartPage)
            .then(function () { if (onCartPage) location.reload(); })
            .catch(function () { up.classList.remove('is-loading'); });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.el && !self.el.hidden) self.close(); });
    },
    open: function () { if (this.el) { this.el.hidden = false; lockScroll(true); } },
    close: function () { if (this.el) { this.el.hidden = true; lockScroll(false); } },
    refresh: function () {
      var self = this;
      return fetch(routes.root + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#rw-cartdrawer-contents');
          var current = $('#rw-cartdrawer-contents', self.el);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          upsellFill();
        })
        .catch(function () {});
    },
    changeLine: function (line, qty) {
      var self = this;
      return fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); bundleGuard(cart); return self.refresh(); })
        .catch(function () {});
    }
  };

  /* bundel-waker: BUNDEL20 is alleen geldig zolang ALLE items van de toegevoegde bundel
     nog in de winkelwagen zitten. Item weg -> discount-cookie overschrijven met een
     niet-bestaande code zodat de echte prijzen terugkomen bij het afrekenen. */
  function bundleGuard(cart) {
    var raw = null;
    try { raw = JSON.parse(localStorage.getItem('rwBundle') || 'null'); } catch (e) {}
    if (!raw || !raw.length) return;
    var check = function (c) {
      var present = (c.items || []).map(function (i) { return i.variant_id || i.id; });
      var complete = raw.every(function (vid) { return present.indexOf(vid) !== -1; });
      if (!complete) {
        localStorage.removeItem('rwBundle');
        // discount-cookie wissen (alle domein/pad-varianten) zodat de echte prijzen terugkomen
        var exp = ';expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        document.cookie = 'discount_code=' + exp;
        document.cookie = 'discount_code=' + exp + ';domain=' + location.hostname;
        document.cookie = 'discount_code=' + exp + ';domain=.' + location.hostname.split('.').slice(-2).join('.');
        // de code hangt ook server-side aan de cart: expliciet losmaken
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
      }
    };
    if (cart && cart.items) check(cart);
    else fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(check).catch(function () {});
  }
  window.RewayBundleGuard = bundleGuard;

  /* cart-upsell vullaag: als de deterministische server-regels minder dan het maximum
     opleverden (bv. boeken), aanvullen met Shopify's per-product Recommendations API
     (gedragsdata, geen willekeur). Games alleen zelfde platform; nooit consoles,
     nooit items die al in de cart zitten of al voorgesteld zijn. */
  function upsellFill() {
    $$('[data-rw-upsell]').forEach(upsellFillBox);
  }
  function upsellFillBox(box) {
    if (!box || box.dataset.rwFilled) return;
    var need = parseInt(box.dataset.rwUpsellNeed || '0', 10);
    if (need <= 0) return;
    var src = [];
    try { src = JSON.parse(box.dataset.rwUpsellSrc || '[]'); } catch (e) {}
    if (!src.length) return;
    box.dataset.rwFilled = '1';
    var exclude = box.dataset.rwUpsellCart || '|';
    $$('[data-rw-upsell-handle]', box).forEach(function (r) { exclude += (r.dataset.rwUpsellHandle || '') + '|'; });
    var list = box.querySelector('.rw-upsell__list');
    if (!list) return;
    function tryNext(i) {
      if (need <= 0 || i >= src.length) return;
      var s = src[i];
      fetch('/recommendations/products?section_id=rw-related&product_id=' + s.id + '&limit=8&intent=related')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          if (!t) { tryNext(i + 1); return; }
          var d = document.createElement('div');
          d.innerHTML = t;
          var cards = Array.prototype.slice.call(d.querySelectorAll('[data-rw-rec]')).filter(function (c) {
            if (c.dataset.rwRecType === 'Consoles') return false;
            if (s.kind === 'game' && (c.dataset.rwRecType !== 'Games' || (c.dataset.rwRecTags || '').indexOf('|' + s.plat + '|') === -1)) return false;
            var a = c.querySelector('a[href*="/products/"]');
            if (!a) return false;
            var h = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
            if (!h || exclude.indexOf('|' + h + '|') !== -1) return false;
            c.__rwHandle = h;
            return true;
          });
          function addOne(j) {
            if (need <= 0 || j >= cards.length) { tryNext(i + 1); return; }
            var h = cards[j].__rwHandle;
            fetch('/products/' + h + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (p) {
                var v = p ? (p.variants || []).filter(function (x) { return x.available; })[0] : null;
                if (!v) { addOne(j + 1); return; }
                // benoemde variant (conditie) -> laten kiezen op de productpagina, niet blind toevoegen
                var onlyDefault = p.variants.length === 1 && p.variants[0].title === 'Default Title';
                var img = p.featured_image ? String(p.featured_image) : '';
                if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
                var row = document.createElement('div');
                row.className = 'rw-upsell__item';
                row.setAttribute('data-rw-upsell-handle', h);
                row.innerHTML =
                  '<a href="/products/' + h + '" class="rw-upsell__img">' + (img ? '<img src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '') + '</a>' +
                  '<div class="rw-upsell__body"><a href="/products/' + h + '" class="rw-upsell__name">' + escHtml(p.title) + '</a>' +
                  '<span class="rw-upsell__price">' + moneyEuro(v.price) + '</span></div>' +
                  (onlyDefault
                    ? '<button type="button" class="rw-upsell__add" data-rw-upsell-add="' + v.id + '" aria-label="Voeg toe aan winkelwagen">+</button>'
                    : '<a class="rw-upsell__add" href="/products/' + h + '" aria-label="Kies een optie">&rsaquo;</a>');
                list.appendChild(row);
                exclude += h + '|';
                need -= 1;
                box.classList.remove('is-empty');
                addOne(j + 1);
              })
              .catch(function () { addOne(j + 1); });
          }
          addOne(0);
        })
        .catch(function () { tryNext(i + 1); });
    }
    tryNext(0);
  }

  function updateCartCount(n) {
    $$('[data-rw-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.classList.contains('rw-cart-count')) el.hidden = n === 0;
    });
  }

  /* ------------------------------------------------------- add to cart */
  function addToCart(items, openDrawer) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function (added) {
        var addedId = (items && items[0]) ? items[0].id : null;
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          bundleGuard(cart);
          // titel/variant/foto/prijs uit cart.js (centen, betrouwbaar); /cart/add geeft prijzen als strings in hele euro's
          var line = null;
          if (addedId != null && cart.items) line = cart.items.filter(function (x) { return x.id === addedId || x.variant_id === addedId; })[0];
          if (!line) line = (added && added.items) ? added.items[0] : added;
          // staat de quick-shop open? eerst dat paneel sluiten, dan de popup net erna tonen
          var qs = document.querySelector('[data-rw-quickshop]');
          if (qs && !qs.hidden && QuickShop) { QuickShop.hide(); setTimeout(function () { showAdded(line, cart); }, 220); }
          else { showAdded(line, cart); }
          return CartDrawer.refresh().then(function () { if (openDrawer !== false) CartDrawer.open(); });
        });
      });
  }

  /* ----------------------------------- "toegevoegd aan winkelwagen" popup */
  var addedTimer;
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function moneyEuro(v) {
    var cents = (typeof v === 'string') ? Math.round(parseFloat(v) * 100) : v;   // cart.js = centen (int); /cart/add = hele euro's (string)
    if (cents == null || isNaN(cents)) return '';
    var s = (cents / 100).toFixed(2).replace('.', ','); if (s.slice(-3) === ',00') s = s.slice(0, -3); return '&euro; ' + s;
  }
  function showAdded(line, cart) {
    if (!line) return;
    if (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches) return;   // alleen desktop, niet op telefoon/tablet
    var el = document.getElementById('rw-added-popup');
    if (!el) { el = document.createElement('div'); el.id = 'rw-added-popup'; el.hidden = true; document.body.appendChild(el); }
    var img = line.image || (line.featured_image && line.featured_image.url) || '';
    var vt = (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : '';
    var price = (line.final_price != null ? line.final_price : line.price);
    var n = cart ? cart.item_count : null;
    el.innerHTML =
      '<div class="rw-added__ov">' +
        '<div class="rw-added__box" role="status" aria-live="polite" aria-label="Toegevoegd aan je winkelwagen">' +
          '<div class="rw-added__check"><svg viewBox="0 0 24 24" width="33" height="33" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path class="rw-added__tick" d="M5 13l4 4 10-12"/></svg></div>' +
          '<div class="rw-added__h">Toegevoegd aan je winkelwagen!</div>' +
          '<div class="rw-added__prod">' +
            (img ? '<img class="rw-added__img" src="' + escHtml(img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
            '<div class="rw-added__pi">' +
              '<div class="rw-added__pt">' + escHtml(line.product_title || line.title) + '</div>' +
              (vt ? '<div class="rw-added__pv">' + escHtml(vt) + '</div>' : '') +
              '<div class="rw-added__pp">' + moneyEuro(price) + '</div>' +
            '</div>' +
          '</div>' +
          (n != null ? '<div class="rw-added__count">' + n + (n === 1 ? ' artikel' : ' artikelen') + ' in je winkelwagen</div>' : '') +
        '</div>' +
      '</div>';
    el.hidden = false;
    el.classList.remove('is-leaving');
    clearTimeout(addedTimer);
    addedTimer = setTimeout(closeAdded, 1300);   // ~1,5 seconde zichtbaar (1300ms + 220ms fade), ook bij hover (geen pauze)
  }
  function closeAdded() {
    var el = document.getElementById('rw-added-popup');
    if (!el || el.hidden || el.classList.contains('is-leaving')) return;
    clearTimeout(addedTimer);
    el.classList.add('is-leaving');
    setTimeout(function () { el.hidden = true; el.innerHTML = ''; el.classList.remove('is-leaving'); }, 220);
  }

  function initAddForms() {
    /* RW-C01 (GA4-nalopen 29-09-2026): capture op window en stopPropagation. Shopify hangt zelf een submit-listener aan
       form[action="/cart/add"] en telt daarna ook de fetch hieronder; zonder dit 2x add_to_cart per klik. */
    window.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-rw-add-form]');
      if (!form) return;
      e.stopPropagation();
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.classList.add('is-loading');
      addToCart([{ id: parseInt(id.value, 10), quantity: 1 }]).then(function () {
        if (btn) btn.classList.remove('is-loading');
      }).catch(function () { if (btn) btn.classList.remove('is-loading'); });
    }, true);
    // data-rw-add buttons (cards / quick-shop) carrying a variant id
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-add]');
      if (!b) return;
      e.preventDefault();
      b.classList.add('is-loading');
      addToCart([{ id: parseInt(b.getAttribute('data-rw-add'), 10), quantity: 1 }]).then(function () {
        b.classList.remove('is-loading');
      }).catch(function () { b.classList.remove('is-loading'); });
    });
  }

  /* --------------------------------------------------- predictive search
     Section Rendering API: /search/suggest?...&section_id=predictive-search
     (server-rendered products + query suggestions + collections). Debounced + cached. */
  var predictiveCache = {};
  function initPredictiveSearch() {
    $$('[data-rw-search]').forEach(function (root) {
      var input = $('[data-rw-predictive]', root);
      var results = $('[data-rw-predictive-results]', root);
      var clear = $('[data-rw-search-clear]', root);
      if (!input || !results) return;
      var timer, ctrl, lastQ = '';
      function hide() { results.hidden = true; }
      function show(html, q) { results.innerHTML = html; lastQ = q; results.hidden = !html; bindRows(); }
      function bindRows() {
        var rows = results.querySelectorAll('.rw-ps__row, .rw-ps__all');
        results.querySelectorAll('[data-ps-url], .rw-ps__all').forEach(function (a) {
          a.addEventListener('mousedown', function (e) { e.preventDefault(); window.location.href = a.getAttribute('href'); });
        });
        return rows;
      }
      var scope = root.getAttribute('data-rw-scope') || '';   // in-collectie zoek-scope (tag:"..."), leeg = globaal
      function run(q) {
        var fq = scope ? (q + ' ' + scope) : q;
        var key = (scope ? scope + '|' : '') + q.toLowerCase();
        if (predictiveCache[key] != null) { show(predictiveCache[key], q); return; }
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(fq) +
          '&section_id=predictive-search' +
          '&resources[type]=product,query,collection&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            // The endpoint returns a full section wrapper; extract the inner .rw-ps if present
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ps = doc.querySelector('.rw-ps');
            var out = ps ? ps.outerHTML : '';
            predictiveCache[key] = out;
            if (input.value.trim() === q) show(out, q);
          })
          .catch(function () {});
      }
      input.setAttribute('autocomplete', 'off');
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clear) clear.hidden = !q;
        clearTimeout(timer);
        if (q.length < 2) { hide(); return; }
        timer = setTimeout(function () { run(q); }, 200);
      });
      input.addEventListener('focus', function () {
        var q = input.value.trim();
        if (q.length >= 2 && q === lastQ && results.innerHTML) results.hidden = false;
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { hide(); }
        else if (e.key === 'ArrowDown' && !results.hidden) {
          var first = results.querySelector('.rw-ps__row');
          if (first) { e.preventDefault(); first.focus(); }
        }
        else if (e.key === 'Enter') {
          /* Enter → altijd naar de volledige zoekresultatenpagina (laat het formulier submitten), niet naar het eerste resultaat */
          hide();
        }
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) hide(); });
      if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; hide(); input.focus(); });
    });
  }

  /* ------------------------------------------------------- quick-shop */
  var QuickShop = null;
  function initQuickShop() {
    var modal = $('[data-rw-quickshop]');
    if (!modal) return;
    var body = $('[data-rw-qs-body]', modal);
    function open() { modal.hidden = false; lockScroll(true); }
    function close() { modal.hidden = true; lockScroll(false); body.innerHTML = '<div class="rw-qs__loading">…</div>'; }
    // soft-hide: dismiss the quick-shop after add-to-cart so the cart drawer becomes the visible popup.
    // De quick-shop liet zijn eigen scroll-lock vrij (ref-counted): de drawer neemt daarna een eigen lock,
    // zodat sluiten van de drawer de pagina weer volledig ontgrendelt (anders blijft overflow:hidden hangen).
    QuickShop = { hide: function () { modal.hidden = true; body.innerHTML = '<div class="rw-qs__loading">…</div>'; lockScroll(false); } };
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-qs-close]') || e.target.matches('.rw-qs__overlay')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    function openHandle(handle) {
      open();
      // cache-buster: voorkom dat een gecachte (oude) sectie-render geserveerd wordt; quick-shop moet altijd actueel zijn (voorraad/condities)
      return fetch(routes.root + 'products/' + handle + '?section_id=quick-shop-card&_=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-rw-qs-render]');
          body.innerHTML = inner ? inner.innerHTML : '<div class="rw-qs__loading">—</div>';
        }).catch(function () { close(); });
    }
    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-rw-quickshop-open]');
      if (!trig) return;
      e.preventDefault();
      openHandle(trig.getAttribute('data-rw-quickshop-open'));
    });
    // Debug hook: ?rwqs=1 auto-opens the first quick-shop (for screenshots). rwqs=2 also expands sold-out.
    if (location.search.indexOf('rwqs=') !== -1) {
      setTimeout(function () {
        var t = document.querySelector('[data-rw-quickshop-open]');
        if (t) openHandle(t.getAttribute('data-rw-quickshop-open')).then(function () {
          if (location.search.indexOf('rwqs=2') !== -1) {
            setTimeout(function () {
              var more = modal.querySelector('[data-rw-show-soldout]');
              if (more) more.click();
            }, 500);
          }
        });
      }, 400);
    }
  }

  /* ------------------------------------------------------- trust pill */
  function wkEsc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function wkInitials(name) { var p = (name || '').trim().split(/\s+/); return ((p[0] || '')[0] || '' ) + ((p[1] || '')[0] || ''); }
  function wkStars(n) { n = Math.max(1, Math.min(5, n || 5)); return '★'.repeat(n); }
  function renderWkReviews() {
    var el = document.getElementById('rw-wk-reviews');
    if (!el) return;
    var wk; try { wk = JSON.parse(el.textContent); } catch (e) { return; }
    var revs = (wk && wk.reviews) || [];
    /* Sjaak 06-09-2026: 1- en 2-sterrenreviews niet op de eigen site tonen (pill + reviewvenster);
       wie ze wil lezen vindt ze volledig op WebwinkelKeur zelf. */
    revs = revs.filter(function (r) { var n = Number(r && r.rating); return !(n >= 1 && n <= 2); });
    // document-breed alle zichtbare aantallen + scores live bijwerken (nette NL-notatie: 5.692)
    if (wk.total) {
      var totalFmt = Number(wk.total).toLocaleString('nl-NL');
      document.querySelectorAll('[data-rw-wk-total]').forEach(function (t) { t.textContent = totalFmt; });
    }
    if (wk.average) {
      document.querySelectorAll('[data-rw-wk-avg]').forEach(function (a) { a.textContent = wk.average; });
    }
    var pillBox = document.querySelector('[data-rw-wk-reviews-pill]');
    if (pillBox && revs.length) {
      pillBox.innerHTML = revs.slice(0, 5).map(function (r) {
        return '<div class="rw-wk__review"><div class="rw-wk__rtop"><span class="rw-wk__ravatar">' + wkEsc(wkInitials(r.name).toUpperCase()) + '</span><span class="rw-wk__rname">' + wkEsc(r.name) + '</span><span class="rw-wk__stars rw-wk__stars--sm">' + wkStars(r.rating) + '</span></div><p class="rw-wk__rquote">' + wkEsc(r.comment) + '</p></div>';
      }).join('');
    }
    var modalBox = document.querySelector('[data-rw-wk-reviews-modal]');
    if (modalBox && revs.length) {
      modalBox.innerHTML = revs.map(function (r) {
        return '<div class="rw-wkm__review"><div class="rw-wkm__rhead"><span class="rw-wkm__ravatar">' + wkEsc(wkInitials(r.name).toUpperCase()) + '</span><span class="rw-wkm__rmeta"><span class="rw-wkm__rname">' + wkEsc(r.name) + '</span><span class="rw-wkm__rverified">✓ Geverifieerde klant · ' + wkEsc(r.date) + '</span></span><span class="rw-wkm__rstars">' + wkStars(r.rating) + '</span></div><p class="rw-wkm__rquote">' + wkEsc(r.comment) + '</p></div>';
      }).join('');
    }
  }

  function initTrustPill() {
    renderWkReviews();
    var pill = $('[data-rw-trustpill]');
    if (!pill) return;
    try { if (sessionStorage.getItem('rw-wk-closed') === '1') { pill.hidden = true; } } catch (e) {}
    var closeBtn = $('[data-rw-wk-close]', pill);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      pill.hidden = true;
      try { sessionStorage.setItem('rw-wk-closed', '1'); } catch (e) {}
    });
    // drag to reposition (pointer)
    var grip = $('[data-rw-wk-drag]', pill);
    if (grip) {
      var sx, sy, ox, oy, dragging = false;
      grip.addEventListener('pointerdown', function (e) {
        dragging = true; pill.classList.add('is-dragging');
        var r = pill.getBoundingClientRect();
        sx = e.clientX; sy = e.clientY; ox = r.left; oy = r.top;
        grip.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      grip.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var nx = Math.max(6, Math.min(window.innerWidth - pill.offsetWidth - 6, ox + (e.clientX - sx)));
        var ny = Math.max(6, Math.min(window.innerHeight - pill.offsetHeight - 6, oy + (e.clientY - sy)));
        pill.style.left = nx + 'px';
        pill.style.top = ny + 'px';
        pill.style.bottom = 'auto';
      });
      grip.addEventListener('pointerup', function () { dragging = false; pill.classList.remove('is-dragging'); });
    }
    // WebwinkelKeur reviews modal (opens on same page)
    var modal = $('[data-rw-wk-modal]');
    if (modal) {
      $$('[data-rw-wk-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); modal.hidden = false; lockScroll(true); });
      });
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-rw-wk-modal-close]') || e.target.matches('.rw-wkm__overlay')) { modal.hidden = true; lockScroll(false); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; lockScroll(false); } });
      if (location.search.indexOf('rwwk=1') !== -1) { setTimeout(function () { modal.hidden = false; }, 300); }
    }
  }

  /* ------------------------------------------------- cart page qty steppers */
  function initCartQty() {
    var form = document.getElementById('rw-cart-form');
    if (!form) return;
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rw-qty]');
      if (!btn) return;
      var row = btn.closest('.rw-cartrow');
      var input = row && row.querySelector('[data-rw-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      v = btn.getAttribute('data-rw-qty') === 'inc' ? v + 1 : Math.max(0, v - 1);
      input.value = v;
      form.submit();
    });
  }

  /* ----------------------------------------- favorieten (lokaal opgeslagen, geen header-teller) */
  var FAV_KEY = 'reway_favs';
  function favGet() { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '{}'); } catch (e) { return {}; } }
  function favSet(o) { try { localStorage.setItem(FAV_KEY, JSON.stringify(o)); } catch (e) {} }
  function favSnap(b) {
    return {
      handle: b.getAttribute('data-rw-wish'),
      title: b.getAttribute('data-fav-title') || '',
      url: b.getAttribute('data-fav-url') || '',
      img: b.getAttribute('data-fav-img') || '',
      price: b.getAttribute('data-fav-price') || '',
      vendor: b.getAttribute('data-fav-vendor') || '',
      cond: b.getAttribute('data-fav-cond') || ''
    };
  }
  function favMark() {
    var favs = favGet();
    $$('[data-rw-wish]').forEach(function (b) { b.classList.toggle('is-active', !!favs[b.getAttribute('data-rw-wish')]); });
  }
  function initFavorites() {
    favMark();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rw-wish]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-rw-wish'); if (!h) return;
      var favs = favGet();
      if (favs[h]) { delete favs[h]; } else { favs[h] = favSnap(b); }
      favSet(favs);
      $$('[data-rw-wish="' + h + '"]').forEach(function (x) { x.classList.toggle('is-active', !!favs[h]); });
      if (typeof window.RewayFavRender === 'function') window.RewayFavRender();
    });
  }
  window.RewayFavGet = favGet;
  window.RewayFavMark = favMark;   // herbruik na live grid-updates (in-categorie zoeken)

  /* ------------------------------------------------------------- boot */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    CartDrawer.init();
    upsellFill();
    initAddForms();
    initPredictiveSearch();
    initQuickShop();
    initCartQty();
    initTrustPill();
    initFavorites();
    bundleGuard();       // bundel-integriteit checken bij elke paginalading
  });
  window.RewayCart = CartDrawer;
  window.RewayAddToCart = addToCart;   // bundels (rw-bundle) voegen meerdere items in één keer toe
})();
